import type { CommandContext } from './CommandContext';

export function canUndo(context: CommandContext): boolean {
  return context.undoManager.canUndo;
}

export function undo(context: CommandContext) {
  const { undoManager } = context;
  if (!undoManager.canUndo) {
    return;
  }
  const result = undoManager.revertToLastUndoState();
  context.update(result);
}

export function canRedo(context: CommandContext): boolean {
  return context.undoManager.canRedo;
}

export function redo(context: CommandContext) {
  const { undoManager } = context;
  if (!undoManager.canRedo) {
    return;
  }
  const result = undoManager.revertToLastRedoState();
  context.update(result);
}
